<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row" v-if="userData.permissions['view_closedloans'] == 1 && userData.permissions['view_loans'] == 1">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <span class="d-flex justify-content-between mb-2">
              <div class="d-flex justify-content-between">
                <div><label>From</label><input class="form-control" v-model="date_from" type="date"></div>
                <div class="mx-1"><label>To</label><input class="form-control" v-model="date_to" type="date"></div>
                <div class="mt-4"><b-button variant="primary" @click="FilterData"><i class="mdi mdi-filter"></i>  Filter</b-button></div>
              </div>
            </span>
            <div class="clearfix"></div>
            <div class="row">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show <b-form-select class="form-select form-select-sm mx-1" v-model="perPage" size="sm"
                      :options="Options"></b-form-select> entries
                  </label>
                </div>
              </div>
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                  <label class="d-inline-flex align-items-center">
                    Search: <b-form-input v-model="filter" type="search" placeholder="Search..."
                      class="form-control form-control-sm ms-2"></b-form-input>
                  </label>
                </div>
              </div>
            </div>
            <div class="table-responsive">
              <b-table :items="Items" :fields="Fields" responsive="sm" :per-page="perPage" :current-page="currentPage"
                :filter="filter" :filter-included-fields="filterOn" @filtered="Filtered" :busy="IsBusy">
                <template #table-busy>
                  <div class="text-center text-primary my-2"><b-spinner v-if="isBusy" class="align-middle" type="grow"
                      small></b-spinner> <i v-else class="fs-5 mdi mdi-cancel"></i> <strong>{{ isBusy ? 'Fetching Data...' : 'No Data Found' }}</strong></div>
                </template>
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(member)="data">
                  <router-link :to="{
                    path: '/memberprofile',
                    query: { id: data.item.member.member_id },
                  }">
                    <span @mouseover="name_hover = true; current_index = data.index" @mouseout="name_hover = false">
                      <span
                        :class="(name_hover && current_index == data.index) ? 'fw-bold text-dark text-decoration-underline' : 'text-dark'">{{
                          data.item.member.name }}</span>
                      <span class="d-block text-info fw-bold">{{ data.item.member.member_id }}</span>
                    </span>
                  </router-link>
                </template>
                <template #cell(loan_type)="data">
                  <b><span class="text-info">{{ data.item.loan_type.name }}</span> <br>
                    <small>{{ data.item.loan_type.rate }}%</small> &nbsp;&nbsp;&nbsp;
                    <small>{{ data.item.loan_type.period }}days</small></b>
                </template>
                <template #cell(amount)="data">
                  {{ commas(data.item.amount) }}
                </template>
                <template #cell(interest)="data">
                  {{ commas(data.item.interest) }}
                </template>
                <template #cell(payback)="data">
                  {{ commas(data.item.payback) }}
                </template>
                <template #cell(expirydate)="data">
                  <span>{{ data.item.expirydate }}</span>
                </template>
                <template #cell(repaymentplan)="data">
                  {{ commas(data.item.repaymentplan) }} <small class="text-info">/</small> {{
                    data.item.repaymentstructure }}
                </template>
                <template #cell(paid)="data">
                  {{ commas(data.item.paid) }}
                </template>
                <template #cell(charges)="data">
                  {{ commas(data.item.charges) }}
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col-3">
                <b>Total Loans : <span class="text-info">{{ commas(totalloan) }}/=</span></b>
              </div>
              <div class="col-3">
                <b>Total Amount Paid : <span class="text-info">{{ commas(totalpaid) }}/=</span></b>
              </div>
              <div class="col-3">
                <b>Total Charges : <span class="text-info">{{ commas(totalcharge) }}/=</span></b>
              </div>
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <b-pagination v-model="currentPage" :total-rows="List" :per-page="perPage"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="row justify-content-center">
        <div class="col-md-8 col-xl-6">
          <div>
            <img src="@/assets/images/profile-img.png" alt class="img-fluid" /><br><br>
            <center><span class="text-primary h6">You have no permission to view Closed Loans</span></center>
          </div>
        </div>
      </div>
    </div>

    <b-modal id="get-excel-file" centered title="Closed Loans Template" title-class="font-18" hide-footer>
      <form @submit.prevent="getExcelFile">
        <label>Loan Type</label>
        <v-select :options="loantypes" required placeholder="Select an Option" v-model="loantype" label="name"
          :reduce="loantype => loantype.id"></v-select>
        <hr>
        <div class="row align-items-center">
          <div class="col-3 border-end border-success">
            <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="100" height="100" viewBox="0 0 48 48">
              <path fill="#4CAF50" d="M41,10H25v28h16c0.553,0,1-0.447,1-1V11C42,10.447,41.553,10,41,10z"></path>
              <path fill="#FFF"
                d="M32 15H39V18H32zM32 25H39V28H32zM32 30H39V33H32zM32 20H39V23H32zM25 15H30V18H25zM25 25H30V28H25zM25 30H30V33H25zM25 20H30V23H25z">
              </path>
              <path fill="#2E7D32" d="M27 42L6 38 6 10 27 6z"></path>
              <path fill="#FFF"
                d="M19.129,31l-2.411-4.561c-0.092-0.171-0.186-0.483-0.284-0.938h-0.037c-0.046,0.215-0.154,0.541-0.324,0.979L13.652,31H9.895l4.462-7.001L10.274,17h3.837l2.001,4.196c0.156,0.331,0.296,0.725,0.42,1.179h0.04c0.078-0.271,0.224-0.68,0.439-1.22L19.237,17h3.515l-4.199,6.939l4.316,7.059h-3.74V31z">
              </path>
            </svg>
          </div>
          <div class="col">
            <div><span class="fw-bold">File: </span> Closed Loans Template</div>
            <br>
            <div>
              <div v-if="loader" class="progress">
                <div class="progress-bar" role="progressbar"> {{ progress }}% </div>
              </div>
              <div v-if="loader"><small class="text-success fw-bold">Generating file ....</small></div>
            </div>
          </div>

        </div>
        <br>
        <div class="d-flex justify-content-end">
          <button @click.prevent="$bvModal.hide('get-excel-file')" class="btn btn-outline-danger btn-sm fw-bold">Forget
            it</button>
          <button type="submit" :class="{ disabled: !loantype }"
            class="mx-3 btn btn-sm btn-success fw-bold">Download</button>
        </div>
      </form>
    </b-modal>


    <b-modal id="import-applications" centered title="Import Closed Loans" title-class="font-18" hide-footer>
      <form @submit.prevent="importApplications" enctype="multipart/form-data">
        <label>Loan Type <small class="text-success">Check file</small></label>
        <v-select :options="loantypes" required placeholder="Select an Option" v-model="loantype" label="name"
          :reduce="loantype => loantype.id"></v-select>
        <hr>
        <div class="row align-items-center">
          <div class="col-3 border-end border-success">
            <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="100" height="100" viewBox="0 0 48 48">
              <path fill="#4CAF50" d="M41,10H25v28h16c0.553,0,1-0.447,1-1V11C42,10.447,41.553,10,41,10z"></path>
              <path fill="#FFF"
                d="M32 15H39V18H32zM32 25H39V28H32zM32 30H39V33H32zM32 20H39V23H32zM25 15H30V18H25zM25 25H30V28H25zM25 30H30V33H25zM25 20H30V23H25z">
              </path>
              <path fill="#2E7D32" d="M27 42L6 38 6 10 27 6z"></path>
              <path fill="#FFF"
                d="M19.129,31l-2.411-4.561c-0.092-0.171-0.186-0.483-0.284-0.938h-0.037c-0.046,0.215-0.154,0.541-0.324,0.979L13.652,31H9.895l4.462-7.001L10.274,17h3.837l2.001,4.196c0.156,0.331,0.296,0.725,0.42,1.179h0.04c0.078-0.271,0.224-0.68,0.439-1.22L19.237,17h3.515l-4.199,6.939l4.316,7.059h-3.74V31z">
              </path>
            </svg>
          </div>
          <div class="col">
            <label for="">Upload Excel File</label>
            <input class="form-control" accept=".xls,.xlsx" type="file" @change.prevent="handleFileUpload"> <br>
            <!-- Progress bar -->
            <div v-if="uploading">
              <div class="progress">
                <div class="progress-bar" role="progressbar" :style="{ width: uploadProgress + '%' }"
                  :aria-valuenow="uploadProgress" aria-valuemin="0" aria-valuemax="100">
                  {{ uploadProgress }}%
                </div>
              </div>
            </div>
          </div>

        </div>
        <br>
        <div class="d-flex justify-content-end">
          <button @click.prevent="$bvModal.hide('import-applications')"
            class="btn btn-outline-danger btn-sm fw-bold">Forget
            it</button>
          <button type="submit" :class="{ disabled: !loantype }"
            class="mx-3 btn btn-sm btn-success fw-bold">Uplaod</button>
        </div>
      </form>
    </b-modal>


    <b-modal id="errors" title="Errors" centered title-class="font-18" hide-footer>
      <div class="text-danger">{{ errors }}</div>
    </b-modal>

  </Layout>
</template>

<script>
import axios from "axios";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { closedloanMethods, closedloanComputed, loantypeMethods, loantypeComputed } from "@/state/helpers";

export default {
  page: {
    title: "Closed Loans",
    meta: [{ name: "description", content: appConfig.description, },],
  },
  components: {
    Layout, PageHeader
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("user")),
      title: "Closed Loans",
      items: [{ text: "Dashboard", to: "/", }, { text: "Closed Loans", active: true, },],
      TotalRows: 1,
      currentPage: 1,
      perPage: 10,
      Options: [10, 50, 100, 150, 200],
      filter: null,
      todoFilter: null,
      filterOn: [],
      sortDesc: true,
      isBusy: true,
      fields: [
        { key: 'index', label: '#', visible: true },
        { key: 'id', label: 'ID', visible: false },
        { key: 'member', label: 'Member', visible: true },
        { key: 'loan_type', label: 'Loan Product', visible: true },
        { key: 'amount', label: 'Loan', visible: true },
        { key: 'interest', label: 'Total Interest', visible: true },
        { key: 'paid', label: 'Total Amount Paid', visible: true },
        { key: 'charges', label: 'Charges', visible: true },
        { key: 'expirydate', label: 'Full Repayment', visible: false },
        { key: 'closed_date', label: 'Closed Date', visible: true },
      ],
      date_to: new Date().toLocaleDateString('fr-CA'),
      date_from: new Date().toLocaleDateString('fr-CA'),
      loader: false,
      progress: 0,
      import_file: '',
      errors: '',
      uploading: false,
      uploadProgress: 0,
      loantype: '',
      name_hover: false,
    };
  },
  computed: {
    ...loantypeComputed,
    ...closedloanComputed,
    List() { return this.closedloans.length; },
    Fields() { return this.fields.filter(field => field.visible) },
    Items() { return this.closedloans.map((d) => ({ ...d })) },
    IsBusy() { let a = false; if (this.closedloans.length > 0) { a = false; } else { a = true; } return a },
    totalloan() { var total = 0; this.closedloans.forEach((item) => { var item_total = item.amount; total = Number(total) + Number(item_total); }); return total },
    totalpaid() { var total = 0; this.closedloans.forEach((item) => { var item_total = item.paid; total = Number(total) + Number(item_total); }); return total },
    totalcharge() { var total = 0; this.closedloans.forEach((item) => { var item_total = item.charges; total = Number(total) + Number(item_total); }); return total },
  },
  async mounted() {
    this.fetchLoanTypes();
    await this.fetchClosedLoans();
    this.TotalRows = this.closedloans.length;
    this.isBusy = false;
  },
  methods: {
    ...loantypeMethods,
    ...closedloanMethods,
    commas(x) { return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','); },
    Filtered(filteredItems) {
      this.TotalRows = filteredItems.length;
      this.currentPage = 1;
    },

    getExcelModal() {
      this.loantype = '';
      this.application_date = new Date().toLocaleDateString('fr-CA');
      this.$bvModal.show('get-excel-file');
    },

    async getExcelFile() {
      this.loader = true;
      this.progress = 0;
      let formData = new FormData();
      formData.append('loan_type', this.loantype);
      let url = 'download-closed-template';


      await axios.post(url, formData, {
        onDownloadProgress: (progressEvent) => {
          this.progress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        },
        responseType: 'blob', // To handle the file download
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'Closed_Loans.xlsx'); // Replace with your desired file name
        document.body.appendChild(link);
        link.click();
        link.remove();
      }).catch((error) => {
        alert('Error downloading file:', error);
      }).finally(() => {
        this.loader = false;
      });
    },

    getImportModal() {
      this.loantype = '';
      this.application_date = new Date().toLocaleDateString('fr-CA');
      this.$bvModal.show('import-applications');
    },

    handleFileUpload(event) {
      this.import_file = event.target.files[0]
    },

    async importApplications() {

      if (!this.import_file) {
        alert('Please select a file.');
        return;
      }
      this.uploadProgress = 0;
      this.uploading = true
      this.errors = ''
      let url = '/import-closed'
      let obj = {
        loan_type: this.loantype,
        file: this.import_file
      }

      await axios.post(url, obj, {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        onUploadProgress: progressEvent => {
          this.uploadProgress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        },
      }).then(response => {
        if (response.data.success) {
          this.$toast.success(response.data.success)
          this.selectedFile = 0;
          this.uploadProgress = 0;
          this.fetchClosedLoans();
        }
        else {
          this.errors = response.data.errors || 'Error occured!'
          this.$bvModal.show('errors')
          this.uploadProgress = 0;
        }
      });
    },

    FilterData() {
      this.filterClosedLoans({ datefrom: this.date_from, dateto: this.date_to });
    },
  },
};
</script>